import { useQuery } from "@tanstack/react-query";
import type { FC } from "react";
import { AssociatedFilesView } from "../../components/associatedFiles/AssociatedFilesView";
import { getOrderParticipantListTemplates } from "../ordersApi";

const useListTemplates = (orderId: string) => {
  const { data, isLoading } = useQuery({
    queryKey: ["orders", orderId, "participant-list-templates"],
    queryFn: ({ signal }) => getOrderParticipantListTemplates(orderId, signal),
  });
  return { templates: data, isLoading };
};

interface Props {
  orderId: string;
}

const ListTemplates: FC<Props> = ({ orderId }) => {
  const { templates } = useListTemplates(orderId);
  if (!templates || templates.length === 0) {
    return null;
  }
  return <AssociatedFilesView values={templates} />;
};

export default ListTemplates;
